import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/cn';

const routeLabels: Record<string, string> = {
  dashboard: 'Dashboard',
  leads: 'Leads',
  contacts: 'Contacts',
  companies: 'Companies',
  deals: 'Deals',
  tasks: 'Tasks',
  expenses: 'Expenses',
  financial: 'Financial',
  invoices: 'Invoices',
  payments: 'Payments',
  accounts: 'Accounts',
  transactions: 'Transactions',
  budgets: 'Budgets',
  reports: 'Reports',
  settings: 'Settings',
  profile: 'Profile',
  team: 'Team',
  pipelines: 'Pipelines',
  pipeline: 'Pipeline',
  categories: 'Categories',
  approvals: 'Approvals',
  new: 'Create',
};

export function Breadcrumbs() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs = pathSegments.map((segment, index) => {
    const href = '/' + pathSegments.slice(0, index + 1).join('/');
    const label = routeLabels[segment] || segment;
    const isLast = index === pathSegments.length - 1;

    return { label, href, isLast };
  });

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground">
      <Link to="/dashboard" className="hover:text-foreground transition-colors">
        <Home className="h-4 w-4" />
      </Link>
      {breadcrumbs.map((crumb) => (
        <div key={crumb.href} className="flex items-center space-x-1">
          <ChevronRight className="h-3.5 w-3.5" />
          {crumb.isLast ? (
            <span className={cn('font-medium text-foreground')}>{crumb.label}</span>
          ) : (
            <Link to={crumb.href} className="hover:text-foreground transition-colors">
              {crumb.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
}
